import { ACADEMY_ROUTES } from '@/shared/academy.const'
import { getAcademyDocumentationNavUrl } from '@/shared/academy.utils'

export const SECTION_URL_MAP: Record<string, string> = {
  Documentation: getAcademyDocumentationNavUrl(),
  'Quick Start': ACADEMY_ROUTES.quickStart,
} as const
